import React from "react";
import FarmerInfo from "./selectedFarmer/farmerInfo";
import Notes from "./selectedFarmer/Notes";
import CustomPlans from "./selectedFarmer/myPlans";
import CustomReviews from "./selectedFarmer/myReview";
import { useQuery } from "@tanstack/react-query";
import { getSelectedFarmer } from "../../../service/api";
import { useSearchParams } from "react-router-dom";

function SelectedFarmer() {

  const [searchParams] = useSearchParams()
  const farmerId = searchParams.get('farmerId')
  const query = useQuery(['farmerInfo', farmerId],()=>getSelectedFarmer(farmerId))

  const farmerInfo = query?.data;
  const farmerNotes = query?.data?.farmer?.farmerNotes;
  const farmerPlans = query?.data?.farmer?.questionnaires;
  const farmerVisits = query?.data?.farmer?.visits;
  return (
    <div className="flex flex-col gap-5 p-3">
      <div>
        <FarmerInfo info={farmerInfo}/>
      </div>
      <div>
        <Notes notes={farmerNotes} farmerId={farmerId}/>
      </div>
      <div>
        <CustomPlans plans={farmerPlans} showHeader={false} planData={farmerPlans} />
      </div>
      <div>
        <CustomReviews visits={farmerVisits} showHeader={false}/>
      </div>
    </div>
  );
}

export default SelectedFarmer;
